import { createFileRoute, Outlet } from '@tanstack/react-router';

import { Require } from '~/app/require';

/** Sign in and sign up: only for a person who is signed out. */
export const Route = createFileRoute('/_public')({
  component: () => (
    <Require allow={['signed-out']}>
      <Outlet />
    </Require>
  ),
});
